import "src/pages/home/components/RoomCard/RoomCardXS/sections/shared/Wrapper/Wrapper.css"
import "src/pages/home/components/RoomCard/RoomCardXS/RoomCardXS.css"
import SkeletonItem from "./SkeletonItem"

function SkeletonCardXS() {
    return (
        <div className="room-card--xs__container">
            <div className="room-card--xs__wrapper" style={{ backgroundColor: "var(--white)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SkeletonItem width={22} height={22} borderRadius="50%" />
                    <SkeletonItem width="40%" height={12} borderRadius={6} />
                </div>
                <SkeletonItem width="100%" height={12} borderRadius={6} />
                <SkeletonItem width="80%" height={12} borderRadius={6} style={{ alignSelf: "center" }} />
            </div>
        </div>
    )
}

export default SkeletonCardXS
